export default "__VITE_ASSET__veKF5VX1__"